import makeStyles from "@mui/styles/makeStyles";
import { BLUE, COLOR, YELLOW } from "../components/utils";

export const useProfessionalActionSelectStyles = makeStyles(() => ({
  root: {
    height: 36,
    lineHeight: 1.75,
  },
}));
